import { lazy } from "react";
import Loadable from "components/global/Loadable";
import { Navigate } from "react-router-dom";
import PublicRoute from "./PublicRoute";
import ProtectedRoute from "./ProtectedRoute";
import SongUploadForm from "pages/app/test";
import AdminUsers from "pages/app/admin-users";
import AddAdminUser from "pages/app/admin-users/AddAdminUser";
import EditAdminUser from "pages/app/admin-users/EditAdminUser";



// LAYOUTS
const MainLayout = Loadable(lazy(() => import('layouts/main')));
const BlankLayout = Loadable(lazy(() => import('layouts/blank')));

// APP
const Home = Loadable(lazy(() => import('pages/app/home')));
const Notifications = Loadable(lazy(() => import('pages/app/notifications')));
const SendNotification = Loadable(lazy(() => import('pages/app/notifications/SendNotification')));
const Ads = Loadable(lazy(() => import('pages/app/ads')));
const AddNewAd = Loadable(lazy(() => import('pages/app/ads/AddNewAd')));
const EditAd = Loadable(lazy(() => import('pages/app/ads/EditAd')));
const Users = Loadable(lazy(() => import('pages/app/users')));

const Casts = Loadable(lazy(() => import('pages/app/cast')));
const EditCast = Loadable(lazy(() => import('pages/app/cast/EditCast')));
const AddCast = Loadable(lazy(() => import('pages/app/cast/AddCast')));

const SubCategories = Loadable(lazy(() => import('pages/app/subCategories')));
const AddSubCategory = Loadable(lazy(() => import('pages/app/subCategories/AddSubCategory')));
const EditSubCategory = Loadable(lazy(() => import('pages/app/subCategories/EditSubCategory')));

const Content = Loadable(lazy(() => import('pages/app/content')));
const AddContent = Loadable(lazy(() => import('pages/app/content/AddContent')));
const EditContent = Loadable(lazy(() => import('pages/app/content/EditContent')));


const SongReviews = Loadable(lazy(() => import('pages/app/reviews')));




// AUTH 
const Login = Loadable(lazy(() => import('pages/auth/login')));


// 404
const NotFound = Loadable(lazy(() => import('pages/404')));


const Router = [
    {
        path : '/' ,
        element : <BlankLayout  /> ,       
        children : [
            { path : '/' , exact : true , element : <Navigate to='/auth/login' /> } ,
            { path : '*' , element : <Navigate to='/page-not-found' /> }
        ]
    } ,
    {
        path : '/auth' ,
        element : <BlankLayout  /> ,       
        children : [
            { path : '/auth/login' , exact : true , element : <PublicRoute element={<Login />} /> } ,
            { path : '*' , element : <Navigate to='/page-not-found' /> }
        ]
    } ,
    {
        path : '/app' ,
        element : <MainLayout /> ,
        children : [
            { 
                path : '/app' , 
                exact : true , 
                element : <ProtectedRoute element={<Home />} />
            } ,
            /********** NOTIFICATIONS ***********/
            { 
                path : '/app/notifications' , 
                exact : true , 
                element : <ProtectedRoute element={<Notifications />} />
            } ,
            { 
                path : '/app/notifications/send' , 
                exact : true , 
                element : <ProtectedRoute element={<SendNotification />} />
            } ,
            /********** ADDS ***********/
            { 
                path : '/app/ads' , 
                exact : true , 
                element : <ProtectedRoute element={<Ads />} />
            } ,
            { 
                path : '/app/ads/add' , 
                exact : true , 
                element : <ProtectedRoute element={<AddNewAd />} />
            } ,
            { 
                path : '/app/ads/edit/:id' , 
                exact : true , 
                element : <ProtectedRoute element={<EditAd />} />
            } ,
            /********** USERS ***********/
            { 
                path : '/app/users' , 
                exact : true , 
                element : <ProtectedRoute element={<Users />} />
            } ,
            /********** CASTS ***********/
            { 
                path : '/app/cast' , 
                exact : true , 
                element : <ProtectedRoute element={<Casts />} />
            } ,
            { 
                path : '/app/cast/add' , 
                exact : true , 
                element : <ProtectedRoute element={<AddCast />} />
            } ,
            { 
                path : '/app/cast/edit/:id' , 
                exact : true , 
                element : <ProtectedRoute element={<EditCast />} />
            } ,
            /********** SUB-CATEGORIES ***********/
            { 
                path : '/app/sub-categories' , 
                exact : true , 
                element : <ProtectedRoute element={<SubCategories />} />
            } ,
            { 
                path : '/app/sub-categories/add' , 
                exact : true , 
                element : <ProtectedRoute element={<AddSubCategory />} />
            } ,
            { 
                path : '/app/sub-categories/edit/:id' , 
                exact : true , 
                element : <ProtectedRoute element={<EditSubCategory />} />
            } ,

            /********** CONTENT ***********/
            { 
                path : '/app/content' , 
                exact : true , 
                element : <ProtectedRoute element={<Content />} />
            } ,
            { 
                path : '/app/content/add' , 
                exact : true , 
                element : <ProtectedRoute element={<AddContent />} />
            } ,
            { 
                path : '/app/content/edit/:id' , 
                exact : true , 
                element : <ProtectedRoute element={<EditContent />} />
            } ,
            { 
                path : '/app/content/reviews/:id' , 
                exact : true , 
                element : <ProtectedRoute element={<SongReviews />} />
            } ,
            /********** ADMIN-USERS ***********/
            { 
                path : '/app/admin-users' , 
                exact : true , 
                element : <ProtectedRoute element={<AdminUsers />} />
            } ,
            { 
                path : '/app/admin-users/add' , 
                exact : true , 
                element : <ProtectedRoute element={<AddAdminUser />} />
            } ,
            { 
                path : '/app/admin-users/edit/:id' , 
                exact : true , 
                element : <ProtectedRoute element={<EditAdminUser />} />
            } ,

            { 
                path : '/app/test' , 
                exact : true , 
                element : <ProtectedRoute element={<SongUploadForm />} />
            } ,
            { path : '*' , element : <Navigate to='/page-not-found' /> }
        ]
    } ,
    {
        path : '/page-not-found' ,
        element : <BlankLayout /> ,
        children : [
            { path : '/page-not-found' , element : <NotFound /> }
        ]
    }

]

export default Router;